import * as z from "zod";

export const setMerchantZonosApiKey = {
  name: "setMerchantZonosApiKey" as const,
  input: z.object({ teamId: z.string(), apiKey: z.string().trim().min(1) }),
  output: z.null(),
};
